
export default function CallToAction() {
  const scrollToForm = () => {
    const el = document.getElementById('inquiry-form');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-700">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Stop Leaving Money on the Table
        </h2>
        <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Your bad leads, delinquencies, and judgments are worth real money. Join hundreds of brokers who trust us to deliver results.
        </p>
        <button
          onClick={scrollToForm}
          className="bg-white text-blue-700 px-10 py-4 rounded-lg text-base font-bold hover:bg-blue-50 transition-all duration-300 shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          Claim Your Commissions Now
        </button>
      </div>
    </section>
  );
}
